// src/components/Cart.jsx
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Link } from "react-router-dom";

function Cart() {
  const { cart, updateQty, removeFromCart, clearCart } =
    useContext(CartContext);

  const total = cart
    .reduce((acc, item) => acc + item.price * item.qty, 0)
    .toFixed(2);

  if (cart.length === 0)
    return (
      <div className="cart-empty">
        <h2>Your cart is empty</h2>
        <Link to="/menu">
          <button className="add-btn">Browse Menu</button>
        </Link>
      </div>
    );

  return (
    <div className="cart-container">
      <h2>Your Order</h2>

      {cart.map((item) => (
        <div className="cart-item" key={item.id}>
          <img src={item.img} alt={item.name} />

          <div className="cart-details">
            <h3>{item.name}</h3>
            <p>${item.price.toFixed(2)}</p>

            {/* Quantity Controls */}
            <div className="qty-row">
              <button
                className="qty-btn"
                onClick={() =>
                  updateQty(item.id, item.qty > 1 ? item.qty - 1 : 1)
                }
              >
                -
              </button>

              <span className="qty">{item.qty}</span>

              <button
                className="qty-btn"
                onClick={() => updateQty(item.id, item.qty + 1)}
              >
                +
              </button>
            </div>

            <button
              className="remove-btn"
              onClick={() => removeFromCart(item.id)}
            >
              Remove
            </button>
          </div>
        </div>
      ))}

      <div className="cart-total">
        <h3>Total: ${total}</h3>

        <button className="clear-btn" onClick={clearCart}>
          Clear Cart
        </button>

        <Link to="/checkout">
          <button className="checkout-btn">Proceed to Checkout</button>
        </Link>
      </div>
    </div>
  );
}

export default Cart;
